import isEqual from 'lodash/isEqual';

// This is used to deeply compare object values instead of references
export const isDeepEqual = <T>(item1: T, item2: T): boolean => isEqual(item1, item2);
